import { render, staticRenderFns } from "./CreateWorkflowInstance.vue?vue&type=template&id=17fe06f6&"
import script from "./CreateWorkflowInstance.vue?vue&type=script&lang=js&"
export * from "./CreateWorkflowInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports